module.exports = __webpack_public_path__ + "img/image-bg.72f84fbd.svg";